import { apiFetch } from '@/lib/api-fetch'
import { api } from '@/lib/axios'
import type { AgentChatContext, AgentSession, AgentMessageFromDB } from '../types/agent.types'

export async function fetchAgentSessions(): Promise<AgentSession[]> {
  const response = await api.get<AgentSession[]>('api/agent/sessions')
  if (response.success) return response.data
  throw new Error('Failed to fetch agent sessions')
}

export async function fetchSessionMessages(sessionId: string): Promise<AgentMessageFromDB[]> {
  const response = await api.get<AgentMessageFromDB[]>(`api/agent/sessions/${sessionId}/messages`)
  if (response.success) return response.data
  throw new Error('Failed to fetch session messages')
}

export async function deleteAgentSession(sessionId: string): Promise<void> {
  await api.delete('api/agent/sessions/' + sessionId)
}

export function sendAgentMessage(
  message: string,
  sessionId?: string,
  signal?: AbortSignal,
  context?: AgentChatContext,
): Promise<Response> {
  return apiFetch('/api/agent/chat', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    // `context` is only serialized when provided — default Sergeo requests are byte-identical.
    body: JSON.stringify({ message, sessionId, ...(context ? { context } : {}) }),
    signal,
  })
}
